<template>
  <div>
    <header-wrap></header-wrap>
    <secord-nav></secord-nav>
    <div class="area_title">
      <h1>{{ productCenterPage.title }}</h1>
      <div class="breadcrumb_wrap">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">{{
            navbar.home
          }}</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/prod_center' }">
            <!-- <span class="is-link" @click="onNav"></span> -->
            {{ productCenterPage.title }}
          </el-breadcrumb-item>
          <el-breadcrumb-item>{{
            dataInfo[`${currentLang.prefix}cate_name`] || ""
          }}</el-breadcrumb-item>
        </el-breadcrumb>

        <div class="search-nav">
          <el-input
            v-model="searchKeywords"
            :placeholder="productCenterPage.searchPlaceholder"
          >
            <template slot="append">
              <el-button
                size="mini"
                class="el-icon-search"
                style="color: #333;"
                @click="handleSearch"
              >
              </el-button>
            </template>
          </el-input>
          <!-- <div class="search-nav__tip">
            <i class="el-icon-info"></i>
            <span>{{ productCenterPage.searchTip }}</span>
          </div> -->
        </div>
      </div>
    </div>
    <div class="area_cation">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane
          v-for="(item, index) in nameList"
          :label="item[`${currentLang.prefix}cate_name`]"
          :name="index + ''"
          :key="index"
        ></el-tab-pane>
      </el-tabs>
    </div>

    <div class="product_wrap1">
      <span class="product_title">{{
        detailsInfo[`${currentLang.prefix}cate_name`]
      }}</span>
      <span class="product_content">{{
        detailsInfo[`${currentLang.prefix}summary`]
      }}</span>
    </div>

    <!-- 产品列表 -->
    <div class="product_wrap2">
      <template v-if="productLists.length > 0">
        <div
          class="product_block"
          v-for="(item, index) in productLists"
          :key="index"
        >
          <!-- <div class="product_img">
            <img :src="item.image" alt="" />
          </div> -->
          <img :src="item.image" alt="" class="product_img" />
          <div class="product_name">
            <span v-if="item[`${currentLang.prefix}no`]"
              >【{{ item[`${currentLang.prefix}no`] }}】</span
            >
            <span>{{ item[`${currentLang.prefix}title`] }}</span>
          </div>
          <div class="product_item">
            <div class="product_hover_name">
              {{ item[`${currentLang.prefix}title`] }}
            </div>
            <div
              class="product_hover_content"
              v-html="$convertPxToRem(item[`${currentLang.prefix}content`])"
            ></div>
            <div class="dynamic_btn" @click="changeTab(item.id)">
              <span>MORE</span>
              <img
                class="more_btn"
                src="../../../assets/images/public/arrow1.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="sc_pagi">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="prev, pager,next"
        :total="total"
      >
      </el-pagination>
    </div>
    <footer-wrap></footer-wrap>

    <feedback-popup></feedback-popup>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  getCateListProduct,
  getCateDetailInfo,
  getProductList
} from "@/utils/http.js";

export default {

  data() {
    return {
      searchKeywords: "",
      activeName: "0",
      nameList: [],
      cate_id: "",
      dataInfo: {},
      detailsInfo: {},
      productLists: [],
      total: 0,
      currentPage: 1, // 当前页数，
      pageSize: 12 // 每一页显示的条数
    };
  },

  computed: {
    ...mapGetters(["currentLang"]),
    productCenterPage() {
      return this.currentLang.config.productCenterPage;
    },
    productList() {
      return this.currentLang.config.productCenterPage.productList;
    },
    navbar() {
      return this.currentLang.config.navbar;
    }
  },
  created() {
    if (this.$route.query.page) {
      this.currentPage = parseInt(this.$route.query.page);
    }
  },
  mounted() {
    if (this.$route.query.sonId) {
      this.cate_id = this.$route.query.sonId;
    } else {
      this.cate_id = this.$route.query.parentId;
    }
    this.nameList = [
      { ...this.productList.tabList[0], id: this.$route.query.parentId }
    ];
    this.getProductNameList();
  },
  methods: {
    handleSearch() {
      // console.log("this.searchKeywords : ", this.searchKeywords)
      this.$router.push({
        path: "/prod_search_list",
        query: {
          keywords: this.searchKeywords,
          index: 0,
          parentId: 42,
          from: "prod_center"
        }
      });
    },

    onNav() {
      // this.$router.go(-1);
      this.$router.push({ path: "/prod_center" });
    },

    getProductNameList() {
      getCateListProduct().then(res => {
        // console.log("res ---- ", res);
        if (res.code === 1) {
          this.dataInfo = res.data[this.$route.query.index * 1];
          res.data[this.$route.query.index * 1].cate_list.forEach(item => {
            this.nameList.push(item);
          });
          this.nameList.forEach((item, index) => {
            if (item.id + "" === this.$route.query.sonId) {
              this.activeName = index + "";
            }
          });
          this.getDetails();
          this.fetchProductList();
        }
      });
    },
    getDetails() {
      getCateDetailInfo({
        cate_id: this.cate_id,
        limit: this.pageSize,
        page: this.currentPage
      }).then(res => {
        // console.log(res);
        if (res.code === 1) {
          this.detailsInfo = res.data;
        }
      });
    },
    fetchProductList() {
      const params = {
        parent_id: this.cate_id == this.nameList[0].id ? this.cate_id : 0,
        cate_id: this.cate_id != this.nameList[0].id ? this.cate_id : "",
        limit: this.pageSize,
        page: this.currentPage
      };
      getProductList(params).then(res => {
        if (res.code === 1) {
          this.total = res.data.count;
          this.productLists = res.data.list;
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
          this.total = 0;
          this.productLists = [];
        }
      });
    },
    handleClick(tab) {
      this.activeName = tab.index;
      this.pageSize = 12;
      this.currentPage = 1;

      this.nameList.forEach((item, index) => {
        if (index + "" === tab.index) {
          this.cate_id = item.id;
          this.$router.push({
            query: {
              ...this.$route.query,
              sonId:item.id,
              page: 1
            }
          });
          this.getDetails();
          this.fetchProductList();
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchProductList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.$router.push({
        query: {
          ...this.$route.query,
          page: val
        }
      });
      this.fetchProductList();
    },
    changeTab(id) {
      // this.$router.push('/prod_details')
      this.$router.push({
        path: "/prod_details",
        query: { id: this.cate_id, sonId: id, page: this.currentPage }
      });
    }
  }
};
</script>
<style scoped lang="scss">
.product_hover_content >>> span {
  color: white !important;
}
.area_title {
  width: 100%;
  height: 160px;
  line-height: 160px;
  background: url("../../../assets/images/public/i12.jpg") no-repeat;
  background-size: 100% 100%;
  background-size: cover;
  background-position: center center;
  text-align: center;
  position: relative;
  h1 {
    color: white;
    font-weight: normal;
  }
  .breadcrumb_wrap {
    display: flex;
    justify-content: space-between;
    width: 1200px;
    position: absolute;
    top: 15px;
    left: calc(50% - 600px);
    /deep/ .el-breadcrumb__item {
      span {
        color: #fff;
        font-size: 16px;
        font-weight: normal;
      }
    }

    .search-nav {
      line-height: 1.5;
    }

    .search-nav__tip {
      margin-top: 6px;
      text-align: left;
      font-size: 13px;
      font-weight: 300;
      color: rgba(255, 255, 255, 0.8);
    }

    /deep/ .el-input__inner {
      height: 36px;
      line-height: 36px;
      border: none;
      outline: none;
    }
  }
}
.area_cation {
  display: flex;
  justify-content: center;
  /deep/ .el-tabs {
    width: 100%;
    .el-tabs__header {
      height: 60px;
      line-height: 60px;
      background: #4b4b4b;
      border: 0;
      // width: 1200px;
      margin: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      .el-tabs__nav-wrap {
        height: 100%;
        margin-bottom: 0;
        .el-tabs__nav-scroll {
          height: 100%;
          .el-tabs__nav {
            height: 100%;
            border: 0;
            .el-tabs__item {
              height: 100%;
              color: #979797;
              border-left: none;
              border-bottom: none;
              padding: 0 25px;
              line-height: unset;
              font-size: 16px;
            }
            .is-active {
              background: #646464;
            }
          }
        }
      }
    }
  }
}
.product_wrap1 {
  width: 1200px;
  padding: 60px 0;
  margin: 0 auto;
  text-align: center;
  .product_title {
    width: 100%;
    font-size: 30px;
    display: block;
    color: #323232;
  }
  .product_content {
    width: 100%;
    height: auto;
    margin-top: 40px;
    font-size: 18px;
    line-height: 1.8;
    text-align: justify;
    text-align-last: center;
    color: #555;
    display: block;
  }
}
.product_wrap2 {
  width: 1200px;
  height: auto;
  margin: 0 auto;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .product_block {
    width: calc((100% - 50px) / 3);
    margin-right: 25px;
    margin-bottom: 30px;
    position: relative;
    overflow: hidden;

    .product_img {
      width: 381.33px;
      height: 381.33px;
      border: 1px solid #dedede;
      display: flex;
      align-items: center;
      justify-content: center;
      object-fit: contain;

      /* img {
        width: 100%;
        height: auto;
        display: block;
      } */
    }
    .product_name {
      padding: 25px;
      background: #f5f5f5;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .product_item {
      width: calc(100% - 50px);
      padding: 25px;
      background: #1a4769;
      position: absolute;
      bottom: 0;
      left: 0;
      color: #fff;
      // display: none;
      transform: translateY(100%);
      transition: all 0.4s;

      .product_hover_name {
        font-size: 18px;
      }
      .product_hover_content {
        margin-top: 25px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }
      .dynamic_btn {
        width: 140px;
        height: 45px;
        background: #e8363e;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        margin: 40px 0 0 0;
        cursor: pointer;
        .more_btn {
          width: 40px;
          margin-left: 10px;
        }
      }
    }
  }
  .product_block:nth-child(3n) {
    margin-right: 0;
  }
  .product_block:hover {
    .product_item {
      // display: block;
      transform: translateY(0%);
    }
  }
}
.sc_pagi {
  width: 500px;
  margin: 0 auto 50px;
  display: flex;
  justify-content: center;
  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background: #e8363e;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/home_product_center/productList.vue